import React from 'react'

const cards = [
  {
    title: 'zuverlässig',
    text: 'Professionelle und faire Preisbewertung, schnelle Zahlung und kostenfreie Fahrzeugabmeldung – bei uns bist du in den besten Händen.',
    staticImg: '/images-optimized/Icon_Sicherheit.gif',
    hoverImg: '/images-optimized/Icon_Sicherheit_ani.gif',
  },
  {
    title: 'unkompliziert',
    text: 'Wir sind der perfekte Partner: Autoverkauf ganz entspannt vom Sofa aus – jederzeit und vollkommen stressfrei.',
    staticImg: '/images-optimized/Icon_Couch.gif',
    hoverImg: '/images-optimized/Icon_Couch_ani.gif',
  },
  {
    title: 'kundenorientiert',
    text: 'Fahrzeugdaten eingeben, individuellen Bestpreis erhalten und Auto vollkommen flexibel an einem Ort deiner Wahl abgeben.',
    staticImg: '/images-optimized/Icon_Jederzeit.gif',
    hoverImg: '/images-optimized/Icon_Jederzeit_ani.gif',
  },
  {
    title: 'wertschätzend',
    text: 'Jedes Auto ist kostbar! Damit dein Fahrzeug nach dem Verkauf jemand anderen glücklich machen kann, sorgen wir für eine umfassende Aufbereitung.',
    staticImg: '/images-optimized/Icon_Tranzparenz.gif',
    hoverImg: '/images-optimized/Icon_Tranzparenz_ani.gif',
  },
]

const PlayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-12 h-12" viewBox="0 0 20 20" fill="currentColor">
    <path
      fillRule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
      clipRule="evenodd"
    />
  </svg>
)

const BestChoiceCard = ({ title, text, staticImg, hoverImg, animate }) => (
  <div className="best-choice-card w-full h-full" data-ani={animate ? 'best-choice-tile' : undefined}>
    <div className="flex items-center justify-between mb-4">
      <div className="font-bold text-gray-700">{title}</div>
      <div className="text-blue-300 hover:text-blue-500">
        <PlayIcon />
      </div>
    </div>
    <div className="flex-grow mb-2 text-sm leading-5 text-gray-700">
      <p>{text}</p>
    </div>
    <img src={staticImg} alt={title} className="max-w-full" />
    <img src={hoverImg} alt={title} className="hidden max-w-full" />
  </div>
)

const BestChoiceSection = () => {
  return (
    <section className="container px-5 py-24 mx-auto leading-6 text-gray-800" id="bestChoice">
      <div className="justify-center block w-full text-center">
        <h1 className="box-border mx-0 mt-0 mb-4 text-3xl font-semibold text-gray-700 border-gray-200 lg:text-4xl">
          Dein Auto verkaufen mit <span className="text-brand-fuchsia">autoverkaufen.de</span> &ndash; die beste Wahl!
        </h1>
      </div>
      <div className="mb-4 text-center text-gray-700">
        Verkaufe dein Auto &ndash; ganz bequem online von zu Hause aus. <br />
        Erhalte direkt deinen Bestpreis und buche noch heute einen Abholtermin deiner Wahl.
      </div>

      {/* Mobile slider / stack */}
      <div className="lg:hidden cursor-pointer" data-toggle="best-choice-glider">
        {cards.map((card) => (
          <BestChoiceCard key={`mobile-${card.title}`} {...card} />
        ))}
      </div>

      {/* Desktop grid */}
      <div className="hidden lg:grid lg:grid-cols-4 gap-8 items-stretch trigger-best-choice-ani cursor-pointer w-full">
        {cards.map((card) => (
          <BestChoiceCard key={card.title} {...card} animate />
        ))}
      </div>
    </section>
  )
}

export default BestChoiceSection
